export default route => ({type: route});
